(ns ballot-scout-v2-frontend.widget.views
  (:require
   ["libphonenumber-js" :as libphone :refer (AsYouType)]
   [ballot-scout-v2-frontend.components.icon :refer [icon] :as icon]
   [ballot-scout-v2-frontend.config :as config]
   [ballot-scout-v2-frontend.events :as events]
   [ballot-scout-v2-frontend.subs :as subs]
   [ballot-scout-v2-frontend.widget.events :as e.widget]
   [ballot-scout-v2-frontend.widget.i18n :as i18n :refer [tr]]
   [ballot-scout-v2-frontend.widget.search-results :as results]
   [ballot-scout-v2-frontend.widget.subs :as s.widget]
   [ballot-scout-v2-frontend.widget.translations :as tx]
   [clojure.set :as set]
   [clojure.spec.alpha :as spec]
   [clojure.string :as str]
   [goog.string :as gstr]
   [re-frame.core :as rf]
   [reagent.core :as r]))

(def tablet-width-px 769)
(defn- screen-width []
  (.-width js/screen))

(defn- switch-language!
  [lang-code]
  (rf/dispatch [::e.widget/set-lang-code (keyword lang-code)]))

(defn lang-select
  []
  (let [selected-lang @(rf/subscribe [::s.widget/widget-language])
        right-to-left? @(rf/subscribe [::i18n/right-to-left?])
        wide-endonym-lang? (i18n/wide-endonym-lang? selected-lang)
        langs (sort (keys tx/translations-dict))]
    (when (> (count langs) 1)
      [:div {:class (str "select lang-select-container"
                         (when right-to-left? " rtl"))}
       [:select {:id "lang-select"
                 :aria-label "select language"
                 :class ["lang-select" (when wide-endonym-lang? "wide")]
                 :value (or selected-lang :en)
                 :on-change #(switch-language! (-> % .-target .-value))}
        (for [lang langs]
          ^{:key lang}
          [:option {:value lang}
           (get-in tx/translations-dict [lang :endonym])])]
       [icon ::icon/globe {:class "has-text-grey-darker mx-3"}]])))

(defn faq-url-by-language []
  (if-let [selected-lang @(rf/subscribe [::s.widget/widget-language])]
    (str config/base-faq-url "/faq-" (name selected-lang))
    (str config/default-faq-url)))

(defn tool-info
  []
  (let [right-to-left? @(rf/subscribe [::i18n/right-to-left?])]
    [:div {:class "is-flex is-justify-content-center is-align-items-center mt-2"}
     [:a {:class "is-size-8 has-text-weight-medium has-text-underlined"
          :alt (tr [:search-usage-alttag])
          :href (faq-url-by-language)
          :target "_blank"}
      [icon ::icon/question-circle {:class (if right-to-left? " ml-1" " mr-1")}]
      (tr [:learn-more])]
     [:div {:class "vl mx-2"}]
     [:a {:class "is-size-8 has-text-weight-medium has-text-underlined"
          :href "https://www.democracy.works/privacy"
          :target "_blank"}
      (tr [:privacy])]
     [:div {:class "vl mx-2"}]
     [:a {:class "is-size-8 has-text-weight-medium has-text-underlined"
          :href "https://www.ballotscout.org/terms"
          :target "_blank"}
      (tr [:terms])]]))

(defn footer
  []
  [:div {:class "footer p-0 has-text-centered"}
   [:div
    [:a
     {:href "https://ballotscout.org"
      :target "_blank"}
     [:img {:class "ballot-scout-logo"
            :src "/images/logo.svg"
            :alt (tr [:logo-alt-tag])}]]]
   [tool-info]])

(defn explanation
  [step ballot]
  [:div {:id "explanation" :class "mt-5"} [results/explanation step ballot]])

(defn multiple-elections
  []
  (let [right-to-left? @(rf/subscribe [::i18n/right-to-left?])]
    [:div {:class "notification is-size-6 is-link is-light is-flex is-align-content-center mb-4 p-3"}
     [icon ::icon/layer-group {:class (str "is-size-3 is-flex is-align-items-center" (if right-to-left? " pl-4" " pr-4"))}]
     [:p
      (tr [:we-found-multiple-elections])
      (tr [:choose-an-election])]]))

(defn disclaimer-blurb
  [entity]
  (let [message (or (:partner/widget-disclaimer-text entity)
                    (:jurisdiction/widget-disclaimer-text entity))]
    (when (not (str/blank? message))
      [:p {:class "disclaimer px-2 pt-2 mt-2 has-text-centered"} message])))

(defn contact-details
  [contact]
  [:div {:class "notification is-size-6 p-3 my-4 has-text-centered" :id "contact"}
   (tr [:footer-questions-call]
       (:name contact)
       (when-let [phone (:phone contact)]
         [:a {:class "has-text-link"
              :href (str "tel:" (str/replace phone #"[^\d]" ""))}
          phone]))
   (when-let [email (some-> contact :email str/trim not-empty)]
     [:span (tr [:or-email]
                [:a {:class "has-text-link"
                     :href (str "mailto:" email)}
                 email])])])

(defn contact-buttons
  [{:keys [phone email name]}]
  (let [right-to-left? @(rf/subscribe [::i18n/right-to-left?])]
    [:<>
     (when phone
       [:button {:class "button is-fullwidth is-danger p-3 mt-4"}
        [:a {:class "heading-4 has-text-white is-flex is-align-items-center"
             :href (str "tel:" (str/replace phone #"[^\d]" ""))}
         [icon ::icon/phone-volume {:class (str "contact-icon" (when right-to-left? " rtl"))}]
         (tr [:call-office] name)]])
     (when email
       [:button {:class "button is-fullwidth is-danger p-3 mt-4"}
        [:a {:class "heading-4 has-text-white is-flex is-align-items-center"
             :href (str "mailto:" email)}
         [icon ::icon/envelope-open-text {:class (str "contact-icon" (when right-to-left? " rtl"))}]
         (tr [:email-office] name)]])]))

(def email-re #"^[a-zA-Z0-9.!#$%&'*+\/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)+$")
(defn- valid-email? [s]
  (->> s (re-matches email-re) boolean))

(defn- get-us-e164 [s]
  (-> s (libphone/parsePhoneNumber "US") (.format "E.164")))

(defn- valid-phone? [s]
  (and (not (str/blank? s))
       (libphone/isPossiblePhoneNumber s "US")))

(defn- format-phone-number [s]
  (let [phone-number (libphone/parsePhoneNumber s "US")]
    (gstr/format "+%s %s"
                 (.-countryCallingCode phone-number)
                 (. phone-number formatNational))))

(defn- format-phone-number-for-input
  [s deleting?]
  (if (and s (not deleting?))
    (.input (AsYouType. "US") s)
    s))

(defn notification-label
  [{:keys [id subscribed-atom value-atom default-label-text subscribed-text update-text]}]
  [:div {:class "label is-flex paragraph-2"}
   [:div {:class "has-text-weight-normal"}
    [:label {:for id}
     (cond
       (not @subscribed-atom)
       default-label-text

       (< (screen-width) tablet-width-px)
       (tr [:youre-subscribed])  ;; Show shorter generic subscribed text on mobile

       :else
       subscribed-text)]]
   (when @subscribed-atom  ;; Link to reset the input and update contact info
     [:a {:class "ml-2 has-text-link"
          :on-click #(do (reset! value-atom "")
                         (reset! subscribed-atom false))}
      update-text])])

(defn notification-subscribe-input
  [{:keys [id right-to-left? placeholder icon-key
           danger-atom subscribed-atom value-atom
           on-change-fn]}]
  [:div {:class (str "control is-fullwidth" (if right-to-left? " has-icons-right" " has-icons-left"))}
   [:input {:id id
            :class (str "input"
                        (if @danger-atom " is-danger" " bordered")
                        (if right-to-left? " pr-6" " pl-6"))
            :type "text"
            :placeholder placeholder
            :disabled @subscribed-atom
            :value @value-atom
            :on-click #(reset! danger-atom false)
            :onChange on-change-fn}]
   [:span {:class (str "icon is-small"
                       (cond
                         @danger-atom " has-text-danger-dark"
                         (str/blank? @value-atom) " has-text-grey-light"
                         :else " has-text-dark")
                       (if right-to-left? " is-right border-left" " is-left border-right"))}
    [icon icon-key]]])

(defn notification-subscribe-button
  [{:keys [disable-button right-to-left?
           danger-atom subscribed-atom value-atom
           valid-value-fn subscribe-fn unsubscribe-fn]}]
  [:button {:class (str "button"
                        (if disable-button " has-background-grey-light" " has-background-link")
                        (if right-to-left? " mr-2" " ml-2"))
            :disabled disable-button
            :on-click #(cond @subscribed-atom
                             (do (reset! value-atom "")
                                 (reset! subscribed-atom false)
                                 (unsubscribe-fn))

                             (not (valid-value-fn @value-atom))
                             (reset! danger-atom true)

                             :else
                             (subscribe-fn))}
   (if @subscribed-atom (tr [:unsubscribe]) (tr [:subscribe]))])

(defn notification-input-field
  [{:keys [id danger icon-key  ;; Styling helpers
           label-text subscribed-text update-text placeholder  ;; Text fields
           subscribed? disabled?  ;; Ratoms that influence what text to display
           value valid-value-fn  ;; The input field's text value (ratom) and a fn to validate it
           on-change subscribe-fn unsubscribe-fn]}]  ;; helper fns
  (let [right-to-left? @(rf/subscribe [::i18n/right-to-left?])
        disable-button (or disabled?
                           (and (not @subscribed?)
                                (not (valid-value-fn @value))))]
    [:div {:class "field"}
     [notification-label {:id                 id
                          :subscribed-atom    subscribed?
                          :value-atom         value
                          :default-label-text label-text
                          :subscribed-text    subscribed-text
                          :update-text        update-text}]
     [:div {:class "field-body is-fullwidth is-flex"}
      [notification-subscribe-input  {:id              id
                                      :right-to-left?  right-to-left?
                                      :placeholder     placeholder
                                      :icon-key        icon-key
                                      :danger-atom     danger
                                      :subscribed-atom subscribed?
                                      :value-atom      value
                                      :on-change-fn    on-change}]
      [notification-subscribe-button {:disable-button  disable-button
                                      :right-to-left?  right-to-left?
                                      :danger          danger
                                      :subscribed-atom subscribed?
                                      :value-atom      value
                                      :valid-value-fn  valid-value-fn
                                      :subscribe-fn    subscribe-fn
                                      :unsubscribe-fn  unsubscribe-fn}]]]))

(defn email-subscribe-label-text
  [subscribe-status unsubscribe-status]
  (cond
    (= :sent subscribe-status)
    [:div
     (tr [:check-email])
     [icon ::icon/circle-arrow-right {:class "has-text-link mx-2"}]]

    (= :sent unsubscribe-status)
    [:div
     (tr [:you-have-been-unsubscribed])
     [icon ::icon/circle-check {:class "has-text-danger mx-2"}]]

    :else
    (tr [:send-me-email])))

(defn email-input-field
  []
  (let [voter (first @(rf/subscribe [::s.widget/widget-voter-response]))
        {:keys [firstname lastname]} @(rf/subscribe [::s.widget/widget-search-params])
        subscribed? (r/atom (:voter/email-subscription-active voter))
        subscribe-status (rf/subscribe [::s.widget/widget-email-subscribe-status])
        unsubscribe-status (rf/subscribe [::s.widget/widget-email-unsubscribe-status])
        value (r/atom (if @subscribed? (:voter/email voter) ""))
        danger (r/atom false)
        on-change (fn [e]
                    (rf/dispatch [::e.widget/voter-email-subscribe-reset])
                    (reset! value (-> e .-target .-value))
                    (reset! danger false))]
    (fn []
      (notification-input-field {:id "email-subscription-input"
                                 :danger danger
                                 :label-text (email-subscribe-label-text @subscribe-status @unsubscribe-status)
                                 :subscribed-text (tr [:youve-subscribed] (tr [:email]))
                                 :update-text (tr [:update-email])
                                 :icon-key ::icon/envelope-open-text
                                 :placeholder (tr [:email-address])
                                 :value value
                                 :subscribed? subscribed?
                                 :disabled? (some? @subscribe-status)
                                 :valid-value-fn valid-email?
                                 :on-change on-change
                                 :subscribe-fn #(rf/dispatch [::e.widget/voter-email-subscribe
                                                              (:voter/jurisdiction-id voter)
                                                              (:voter/id voter)
                                                              {:firstname firstname
                                                               :lastname lastname
                                                               :email @value
                                                               :preferred-language (name @(rf/subscribe [::s.widget/widget-language]))}])
                                 :unsubscribe-fn #(rf/dispatch [::e.widget/voter-email-unsubscribe
                                                                (:voter/jurisdiction-id voter)
                                                                (:voter/id voter)
                                                                {:fullname (:voter/fullname voter)}])}))))

(defn sms-subscribe-label-text
  [subscribe-status unsubscribe-status sent-stopcode-to]
  (cond
    (= :sent subscribe-status)
    [:div
     (tr [:check-texts])
     [icon ::icon/circle-arrow-right {:class "has-text-link mx-2"}]]

    (= :sent unsubscribe-status)
    [:div
     (tr [:you-have-been-unsubscribed])
     [icon ::icon/circle-check {:class "has-text-danger mx-2"}]]

    (some? sent-stopcode-to)
    [:div
     (tr [:resubscribe] (format-phone-number sent-stopcode-to))
     [icon ::icon/exclamation-triangle {:class "has-text-warning-dark mx-2"}]]

    :else
    (tr [:send-me-sms])))

(defn sms-input-field
  []
  (let [voter (first @(rf/subscribe [::s.widget/widget-voter-response]))
        {:keys [firstname lastname]} @(rf/subscribe [::s.widget/widget-search-params])
        subscribed? (r/atom (:voter/sms-subscription-active voter))
        subscribe-status (rf/subscribe [::s.widget/widget-sms-subscribe-status])
        unsubscribe-status (rf/subscribe [::s.widget/widget-sms-unsubscribe-status])
        sent-stopcode-to (rf/subscribe [::s.widget/widget-received-stopcode])
        value (r/atom (if @subscribed? (:voter/phone voter) ""))
        danger (r/atom false)
        on-change (fn [e]
                    (rf/dispatch [::e.widget/voter-sms-subscribe-reset])
                    (reset! danger false)
                    (let [new-val (-> e .-target .-value)
                          deleting? (>= (count @value) (count new-val))]
                      (reset! value (format-phone-number-for-input new-val deleting?))))]
    (fn []
      (notification-input-field {:id "sms-subscription-input"
                                 :danger danger
                                 :label-text (sms-subscribe-label-text @subscribe-status @unsubscribe-status @sent-stopcode-to)
                                 :subscribed-text (tr [:youve-subscribed] (tr [:sms]))
                                 :update-text (tr [:update-phone])
                                 :icon-key ::icon/comment-sms
                                 :placeholder (tr [:phone-number])
                                 :value value
                                 :subscribed? subscribed?
                                 :disabled? (or (some? @sent-stopcode-to)
                                                (some? @subscribe-status))
                                 :valid-value-fn valid-phone?
                                 :on-change on-change
                                 :subscribe-fn #(rf/dispatch [::e.widget/voter-sms-check-and-subscribe
                                                              (:voter/jurisdiction-id voter)
                                                              (:voter/id voter)
                                                              {:firstname firstname
                                                               :lastname lastname
                                                               :phone (get-us-e164 @value)
                                                               :preferred-language (name @(rf/subscribe [::s.widget/widget-language]))}])
                                 :unsubscribe-fn #(rf/dispatch [::e.widget/voter-sms-unsubscribe
                                                                (:voter/jurisdiction-id voter)
                                                                (:voter/id voter)
                                                                {:fullname (:voter/fullname voter)}])}))))

(defn notifications-signup
  []
  [:div {:class "notifications-box message is-dark my-4"}
   [:h4 {:class "message-header mb-0 heading-4 is-justify-content-center p-3"}
    (tr [:notifications])]
   [:div {:class "message-body p-2"}
    [email-input-field]
    [sms-input-field]]])

(defn should-allow-notifications? []
  (let [partner (rf/subscribe [::s.widget/widget-partner])
        jurisdiction (rf/subscribe [::s.widget/widget-jurisdiction])
        widget-type (rf/subscribe [::s.widget/widget-type])
        partner-allow-notys (-> @partner :partner/allow-notifications boolean)
        juri-allow-notys (-> @jurisdiction :jurisdiction/allow-notifications boolean)]
    (if (= @widget-type :partner)
      partner-allow-notys
      (and juri-allow-notys partner-allow-notys))))

(defn election-chooser-view
  []
  (let [selected-ballot-id (r/atom nil)
        ballot-response @(rf/subscribe [::s.widget/widget-ballot-response])
        first-ballot (first ballot-response)]
    (rf/dispatch [::events/scroll-to-top])
    (fn []
      [:div {:class "widget-content"}
       [multiple-elections]
       [lang-select]
       [:form
        [:div {:class "disambiguation-options field p-5" :aria-label "select election"}
         (for [b ballot-response]
           (let [{:election/keys [name date]} (:ballot/election b)
                 id (str name "-" date)]
             [:div {:key id :class (str "field" (when (not= b first-ballot) " mt-5"))}
              [:input {:id id
                       :type "radio"
                       :name "ballot"
                       :on-change (fn [_] (reset! selected-ballot-id (:ballot/id b)))}]
              [:label {:class "mx-2 is-size-5 has-text-weight-medium"
                       :for id}
               name]]))]
        [:div {:class "field mt-4"}
         [:div {:class "control"}
          [:button
           {:class "button is-fullwidth"
            :disabled (nil? @selected-ballot-id)
            :on-click (fn [e] ; set the ballot id as selected
                        (.preventDefault e)
                        (rf/dispatch [::e.widget/set-widget-ballot-id @selected-ballot-id])
                        (rf/dispatch [::e.widget/set-form-phase :show-result]))}
           [:div {:class "p-1 is-size-4 has-text-weight-medium"} (tr [:continue])]]]]]
       [contact-details @(rf/subscribe [::s.widget/widget-contact-info])]
       [footer]])))

(defn invalid-keys
  "According to `spec`, which attributes of `m` need some work?"
  [spec m]
  (let [errors (spec/explain-data spec m)]
    (->> errors
         ::spec/problems
         (map :path)
         flatten
         set)))

(defn- search-errors
  "Returns a data structure representing errors in the search form input field
  elements."
  [form-values]
  (let [invalid-keys (invalid-keys :widget/search-schema form-values)]
    invalid-keys))

(def ballot-status-styles
  {:default                       {:icon-key ::icon/envelopes-bulk     :danger false :position 0 :title-key :being-prepared              :explanation-method :not-tracked}
   :disposition/created           {:icon-key ::icon/envelopes-bulk     :danger false :position 0 :title-key :being-prepared              :explanation-method :not-yet-mailed}
   :disposition/mailed            {:icon-key ::icon/envelope           :danger false :position 1 :title-key :mailed-to-voter             :explanation-method :voter-bound-mailed}
   :voter-bound/mailed            {:icon-key ::icon/envelope           :danger false :position 1 :title-key :mailed-to-voter             :explanation-method :voter-bound-mailed}
   :voter-bound/in-transit        {:icon-key ::icon/envelope           :danger false :position 1 :title-key :mailed-to-voter             :explanation-method :voter-bound-mailed}
   :voter-bound/out-for-delivery  {:icon-key ::icon/envelope           :danger false :position 1 :title-key :mailed-to-voter             :explanation-method :voter-bound-mailed}
   :voter-bound/delivered         {:icon-key ::icon/house-chimney      :danger false :position 2 :title-key :delivery-scheduled          :explanation-method :voter-bound-delivered}
   :office-bound/mailed           {:icon-key ::icon/envelope           :danger false :position 3 :title-key :mailed-to-office            :explanation-method :office-bound-in-transit}
   :office-bound/in-transit       {:icon-key ::icon/envelope           :danger false :position 3 :title-key :mailed-to-office            :explanation-method :office-bound-in-transit}
   :office-bound/out-for-delivery {:icon-key ::icon/envelope           :danger false :position 3 :title-key :mailed-to-office            :explanation-method :office-bound-in-transit}
   :office-bound/delivered        {:icon-key ::icon/circle-check       :danger false :position 4 :title-key :received-by-office          :explanation-method :office-bound-delivered}
   :disposition/received          {:icon-key ::icon/circle-check       :danger false :position 4 :title-key :received-by-office          :explanation-method :office-bound-delivered}
   :disposition/accepted          {:icon-key ::icon/circle-check       :danger false :position 4 :title-key :received-by-office-accepted :explanation-method :accepted}
   :disposition/flagged           {:icon-key ::icon/circle-exclamation :danger true  :position 4 :title-key :received-by-office-flagged  :explanation-method :flagged}
   :voter-bound/returned          {:icon-key ::icon/circle-exclamation :danger true  :position 2 :title-key :returned-to-sender          :explanation-method :return-to-sender}
   :office-bound/returned         {:icon-key ::icon/circle-exclamation :danger true  :position 2 :title-key :returned-to-sender          :explanation-method :return-to-sender}})

(defn progress-bar
  [current-position danger]
  [:div {:class "my-5"}
   [:div {:class "progress-bar-container is-flex is-justify-content-center"}
    [:div
     {:class (str "progress-bar my-6 is-flex is-align-content-center is-justify-content-space-between phase-" current-position)}
     (for [i (range 5)]
       (let [current-phase? (= i current-position)]
         [:div {:class "phase"}
          [icon
           (cond
             (and current-phase? danger)       ::icon/circle-exclamation
             (and current-phase? (not danger)) ::icon/circle-check
             :else                             ::icon/circle)
           {:class (str "has-background-white"
                        (cond
                          (and current-phase? danger)               " current-phase has-text-danger-dark"
                          (and current-phase? (not danger))         " current-phase has-text-success-dark"
                          (and (< i current-position) (not danger)) " has-text-success-dark"))}]]))]]])

(defn back-button
  []
  [:button {:class "back-button"
            :aria-label "back to election select"
            :on-click #(do (rf/dispatch [::e.widget/set-form-phase :multiple-elections])
                           (rf/dispatch [::e.widget/set-widget-ballot-id nil]))}
   [icon ::icon/chevron-left {:class "is-size-3"}]])

(defn search-results-view
  []
  (let [ballot @(rf/subscribe [::s.widget/widget-ballot])
        ballot-status (:ballot/status ballot)
        jurisdiction @(rf/subscribe [::s.widget/widget-jurisdiction])
        partner @(rf/subscribe [::s.widget/widget-partner])
        contact-info @(rf/subscribe [::s.widget/widget-contact-info])
        {:keys [icon-key danger position title-key explanation-method]}
        (or (some->> ballot-status keyword (get ballot-status-styles))
            (:default ballot-status-styles))]
    (rf/dispatch [::events/scroll-to-top])
    [:div {:class "search-results widget-content"}
     (when (< 1 (count @(rf/subscribe [::s.widget/widget-ballot-response])))
       [back-button])
     [lang-select]
     [:div {:class "ballot-status has-text-centered"}
      [icon icon-key {:class (str "ballot-status-icon" (if danger " has-text-danger-dark" " has-text-success-dark"))}]
      [:h2 {:class "heading-2 has-text-weight-bold my-1"} (tr [title-key])]
      [results/last-scan-time ballot]
      [progress-bar position danger]
      [explanation explanation-method ballot]]
     (if danger
       [contact-buttons contact-info]
       (when (should-allow-notifications?) [notifications-signup]))
     [contact-details contact-info]
     [footer]
     [disclaimer-blurb partner]
     [disclaimer-blurb jurisdiction]]))

(def states
  ["AK" "AL" "AR" "AS" "AZ" "CA" "CO" "CT" "DC" "DE" "FL" "FM" "GA" "GU" "HI" "IA"
   "ID" "IL" "IN" "KS" "KY" "LA" "MA" "MD" "ME" "MH" "MI" "MN" "MO" "MP" "MS"
   "MT" "NC" "ND" "NE" "NH" "NJ" "NM" "NV" "NY" "OH" "OK" "OR" "PA" "PR" "PW"
   "RI" "SC" "SD" "TN" "TX" "UT" "VA" "VI" "VT" "WA" "WI" "WV" "WY"])

(defn validation-errors
  []
  (let [right-to-left? @(rf/subscribe [::i18n/right-to-left?])]
    [:div {:class "notification is-size-6 is-danger is-light is-flex is-align-items-center mb-4 p-3"}
     [icon ::icon/exclamation-triangle {:class (str "is-size-3" (if right-to-left? " pl-4" " pr-4"))}]
     [:p (tr [:fields-invalid])]]))

(defn search-failed
  []
  (let [right-to-left? @(rf/subscribe [::i18n/right-to-left?])]
    [:div {:class "notification is-size-6 is-danger is-light is-flex is-align-items-center mb-4 p-3"}
     [icon ::icon/exclamation-triangle {:class (str "is-size-3" (if right-to-left? " pl-4" " pr-4"))}]
     [:p (tr [:unable-locate-ballot-2])]]))

(defn multiple-results-blurb
  []
  (let [right-to-left? @(rf/subscribe [::i18n/right-to-left?])]
    [:div {:class "notification is-size-6 is-link is-light is-flex is-align-content-center mb-4 p-3"}
     [icon ::icon/user-friends {:class (str "is-size-3 is-flex is-align-items-center" (if right-to-left? " pl-4" " pr-4"))}]
     [:p (tr [:multiple-ballots-found])]]))

;; TODO: move this spec to another namespace?
(defn- nonempty-string? [x]
  (and (string? x)
       (not (str/blank? x))))

(spec/def ::firstname nonempty-string?)
(spec/def ::lastname  nonempty-string?)
(spec/def ::street    nonempty-string?)
(spec/def ::zip       nonempty-string?)
(spec/def ::city      nonempty-string?)
(spec/def ::state     nonempty-string?)

(spec/def ::street-2 string?)

(spec/def :widget/search-schema
  (spec/keys :req-un [::firstname
                      ::lastname
                      ::street
                      ::zip
                      ::city
                      ::state]
             :opt-un [::street-2]))

(defn send-voter-search! [search-params]
  (let [jurisdiction @(rf/subscribe [::s.widget/widget-jurisdiction]) ;; if partner, get multiple...
        partner @(rf/subscribe [::s.widget/widget-partner])
        populated-values (->> search-params
                              (merge {:partner-id (:partner/id partner)
                                      :jurisdiction-id (:jurisdiction/id jurisdiction)})
                              (filter #(not (str/blank? (second %))))
                              (into {}))] ; only send vals with data
    (rf/dispatch [::e.widget/clear-voter-response])
    (rf/dispatch [::e.widget/set-search-params search-params])
    (rf/dispatch [::e.widget/set-form-phase :searching])
    (rf/dispatch [::e.widget/fetch-voters-for-widget populated-values])))

(defn set-form-invalid! []
  (rf/dispatch [::e.widget/set-form-phase :invalid-form])
  (rf/dispatch [::events/scroll-to-top]))

(defn format-zip [zip-string]
  (let [zip-string (str/replace zip-string #"\-" "")
        zip-string-length (count zip-string)]
    (if (<= zip-string-length 5)
      zip-string
      (str (subs zip-string 0 5) "-" (subs zip-string 5)))))

(defn form-input
  [{:keys [label phase form-state key text required? props]}]
  (let [name (name key)
        value (key @form-state)
        errors (search-errors @form-state)
        invalid-contents? (and (= :invalid-form @phase) (contains? errors key))]
    [:div {:class "field"}
     [:label {:class "label paragraph-2 mb-0" :for name}
      [:div
       label
       (when required?
         [:span {:class (str "ml-1" (when invalid-contents? " has-text-danger-dark"))}
          "*"])]]
     [:div {:class "control"}
      [:input (merge
               {:id name
                :ref name
                :class (str "input" (if invalid-contents? " is-danger" " bordered"))
                :disabled (= phase :searching)
                :placeholder (if invalid-contents? (tr [:required-field]) text)
                :name name
                :type "text"
                :value value
                :onChange (fn [e] (swap! form-state assoc key (-> e .-target .-value)))}
               props)]]]))

(defn state-input
  [{:keys [phase form-state key]}]
  (let [name (name key)
        errors (search-errors @form-state)
        invalid-contents? (and (= :invalid-form @phase) (contains? errors key))]
    [:div {:class "field"}
     [:label {:class "label paragraph-2 mb-0" :for name}
      [:div
       (tr [:state])
       [:span {:class (str "ml-1" (when invalid-contents? " has-text-danger-dark"))}
        "*"]]]
     [:div {:class "control"}
      [:div {:class (str "select is-fullwidth" (if invalid-contents? " is-danger" " has-arrow-dark"))}
       [:select {:id name
                 :ref name
                 :class (str "state-selector-element is-size-7"
                             (if invalid-contents? " is-danger has-text-danger-dark" " bordered")
                             (when (and (not invalid-contents?) (= "" (:state @form-state))) " has-text-grey"))
                 :disabled (= phase :searching)
                 :name name
                 :value (or (:state @form-state) "")
                 :onChange (fn [e] (swap! form-state assoc key (-> e .-target .-value)))}
        [:option {:value "" :class "disabled selected"}
         (if invalid-contents? (tr [:required-field]) (tr [:select-state]))]
        (for [state states]
          ^{:key state} [:option {:value state :class "has-text-dark"} state])]]]]))

(defn submit-form-fn [form-state]
  (fn [e]
    (.preventDefault e)
    (if (seq (search-errors @form-state))
      (set-form-invalid!)
      (send-voter-search! @form-state))))

(defn search-form
  []
  (let [form-state (r/atom {:firstname ""
                            :lastname ""
                            :street ""
                            :street-2 ""
                            :city ""
                            :state ""
                            :zip ""})
        widget-phase (rf/subscribe [::s.widget/widget-phase])
        base-field-params {:phase widget-phase
                           :form-state form-state}
        form-input* (fn [params] [form-input (merge base-field-params params)])]
    (fn []
      [:div {:class "widget-content"}
       (case @widget-phase
         :no-results [search-failed]
         :not-found [search-failed]
         :invalid-form [validation-errors]
         nil)

       [lang-select]

       [:form {:class "pt-4"}
        [:div {:class "field my-3"}
         [:div {:class "label"}
          [:h2 {:class "heading-2 mb-0"} (tr [:name])]
          [:div {:class "paragraph-2 has-text-weight-normal"} (tr [:name-description])]]
         [:div {:class "field-body"}
          [:div {:class "field mb-1"}
           [form-input* {:label (tr [:first-name]) :key :firstname :required? true}]]
          [:div {:class "ml-3"}]  ;; This seems janky
          [:div {:class "field mb-1"}
           [form-input* {:label (tr [:last-name]) :key :lastname :required? true}]]]]
        [:div {:class "field mb-3"}
         [:div {:class "label"}
          [:h2 {:class "heading-2 mb-0"} (tr [:address])]
          [:div {:class "paragraph-2 has-text-weight-normal"} (tr [:address-description])]]
         [:div {:class "field mb-1"}
          [form-input* {:label (tr [:addr-line-1]) :text (tr [:address-1-placeholder]) :key :street :required? true}]]
         [:div {:class "field mb-1"}
          [form-input* {:label (tr [:addr-line-2]) :text (tr [:address-2-placeholder]) :key :street-2}]]
         [:div {:class "field-body address-fields mb-1 is-flex is-align-items-flex-end"}
          [:div {:class "field mb-1 mx-0"}
           [form-input* {:label (tr [:city]) :key :city :required? true}]]
          [:div {:class "state-selector field mb-1"}
           [state-input (merge base-field-params {:key :state})]]
          [:div {:class "field mb-1 mx-0"}
           [form-input* {:label (tr [:zip]) :key :zip :required? true
                         :props {:type "tel"
                                 :onChange (fn [e] (swap! form-state assoc :zip (-> e .-target .-value format-zip)))}}]]]]
        [:div {:class "field"}
         [:div {:class "field-body"}
          [:div {:class "field"}
           [:div {:class "control"}
            [:button
             {:class "button is-fullwidth"
              :disabled (= @widget-phase :searching)
              :onClick (submit-form-fn form-state)}
             [:h3 {:class "p-1 heading-3 has-text-white"} (tr [:track-your-ballot])]]]]]]]
       [contact-details @(rf/subscribe [::s.widget/widget-contact-info])]
       [footer]])))

(defn obscure-voter-name
  [n]
  (apply str (first n) (repeat (dec (count n)) "*")))

(defn split-names [v] (-> v
                          :voter/fullname
                          (str/split #" ")))

(defn voter-name-for-disambiguation
  "Given a voter in a collection of voters, determine the method used to display
  the voter to the user. Try to find an instance of uniqueness and only show that
  for the voter.

  This system is best-effort: there is still the possibility that the same text
  will appear more than once. However, it works in most cases."
  [voter voters]
  (let [voters' (set/difference (set voters) #{voter})
        voter-split-names (split-names voter)
        unique-name-parts (->> voters'
                               (map (comp set split-names))
                               (apply set/union)
                               (set/difference (set voter-split-names)))
        ;; If voter has no unique parts of their name, just show their first name
        to-show (if (empty? unique-name-parts)
                  #{(first voter-split-names)}
                  unique-name-parts)
        index-to-show (->> voter-split-names
                           (filter to-show)
                           first
                           (.indexOf voter-split-names))
        to-join (map-indexed #(if (= index-to-show %1)
                                %2
                                (obscure-voter-name %2))
                             voter-split-names)]
    (str/join " " to-join)))

(defn voter-radio-button
  [id class label f]
  [:div {:class class}
   [:input {:id id
            :name "voter"
            :type "radio"
            :on-change f}]
   [:label {:class "mx-2 is-size-5 has-text-weight-medium"
            :for id}
    label]])

(defn set-selected-voter [voter]
  (rf/dispatch [::e.widget/set-widget-voter (:voter/id voter)])
  (rf/dispatch [::e.widget/clear-ballot-response])
  (let [voter-record (first (filter #(= (:voter/id voter) (:voter/id %)) @(rf/subscribe [::s.widget/widget-voter-response])))
        current-partner @(rf/subscribe [::s.widget/widget-partner])]
    ; proceed to find ballots for voter, whether for partner or jurisdiction
    (rf/dispatch [::e.widget/fetch-ballots-by-voter-id {:jurisdiction-id (:voter/jurisdiction-id voter)
                                                        :partner-id (:partner/id current-partner)
                                                        :voter-id (:voter/id voter)
                                                        :voter.fullname (:voter/fullname voter-record)
                                                        :voter.address-1 (:voter/address-1 voter-record)
                                                        :voter.address-2 (:voter/address-2 voter-record)
                                                        :voter.city (:voter/city voter-record)
                                                        :voter.state (:voter/state voter-record)
                                                        :voter.zip (:voter/zip voter-record)}])))

(defn multiple-voters
  "A secondary search form for disambiguating search results.

  If a user selects \"None of the above\", they are taken back to the search
  form and the search form is set to the `:failed` phase."
  [response]
  (let [selected-voter (r/atom nil)
        voters @response
        inputs (for [v voters]
                 [voter-radio-button
                  (str (:voter/id v))
                  "field mb-4"
                  (voter-name-for-disambiguation v voters)
                  (fn [_] (reset! selected-voter v))])]
    (rf/dispatch [::events/scroll-to-top])
    (fn []
      [:div {:class "widget-content"}
       [multiple-results-blurb]
       [lang-select]
       [:form
        (into [:div {:class "disambiguation-options field p-5"
                     :aria-label "select voter name"}]
              (conj (vec inputs)
                    (voter-radio-button
                     "none-of-the-above"
                     "field"
                     (tr [:none-of-the-above])
                     (fn [_] (reset! selected-voter ::none)))))
        [:div {:class "field mt-4"}
         [:div {:class "control"}
          [:button
           {:class "button is-fullwidth"
            :disabled (nil? @selected-voter)
            :onClick (fn [e]
                       (.preventDefault e)
                       (if (= ::none @selected-voter)
                         (do
                           (rf/dispatch [::e.widget/set-form-phase :no-results])
                           (rf/dispatch [::e.widget/set-widget-voter nil]))
                         (set-selected-voter @selected-voter)))}
           [:div {:class "p-1 is-size-4 has-text-weight-medium"} (tr [:continue])]]]]]
       [contact-details @(rf/subscribe [::s.widget/widget-contact-info])]
       [footer]])))

(defn lang-tag []
  (if-let [lang @(rf/subscribe [::s.widget/widget-language])]
    (name lang)
    "en"))

;; container for displaying the phase of the widget: search-form, results, or intermediate
(defn search-widget
  [show-title]
  (let [voter-response (rf/subscribe [::s.widget/widget-voter-response])
        phase (rf/subscribe [::s.widget/widget-phase])
        lang (rf/subscribe [::s.widget/widget-language])]
    (fn []
      (let [page-phase (or @phase :init)
            lang-dir (if (i18n/rtl-lang? @lang)
                       "rtl"
                       "ltr")]
        [:div {:class "is-flex is-justify-content-center"}
         [:div {:class "search-widget" :dir lang-dir :lang (lang-tag)}
          (case page-phase
            :multiple-elections
            [election-chooser-view]
            :show-result
            [search-results-view]
            :multiple-voters
            [multiple-voters voter-response]
            (:no-results :not-found :init :searching :invalid-form)
            [:<>
             (when show-title
               [:div
                [:h1 {:class "has-text-centered heading-1"}
                 (tr [:track-your-ballot])]
                [:h3 {:class "has-text-centered heading-3 mb-5"}
                 (:name @(rf/subscribe [::s.widget/widget-contact-info]))]])
             [search-form]])]]))))

(defn get-widget [show-title]
  ; TODO: right place to put init sorts of things
  (when-not @(rf/subscribe [::s.widget/widget-language])
    (rf/dispatch [::e.widget/set-lang-code (i18n/default-language)]))
  (when (:jurisdiction/allow-widget @(rf/subscribe [::s.widget/widget-jurisdiction]))
    [search-widget show-title]))

(defn get-partner-widget [show-title]
  (when-not @(rf/subscribe [::s.widget/widget-language])
    (rf/dispatch [::e.widget/set-lang-code (i18n/default-language)]))
  (when (:partner/allow-widget @(rf/subscribe [::s.widget/widget-partner]))
    [search-widget show-title]))

(defn page []
  (get-widget false))

(defn partner-page []
  (get-partner-widget false))

(defn title-page []
  (get-widget true))

(defn title-partner-page []
  (get-partner-widget true))

(defn admin-page []
  (when @(rf/subscribe [::subs/admin?])
    (page)))

(defn admin-partner-page []
  (when @(rf/subscribe [::subs/admin?])
    (partner-page)))

(defn deprecation-message []
  [:div {:class "search-widget"}
   [:div {:class "p-5 has-text-centered"}
    [:img {:src "/images/logo.svg"
           :class "pb-5"
           :alt (tr [:logo-alt-tag])}]
    [:div {:class "deprecation-message"}
     "This tool has a newer version available and requires an update. Please contact your election office."]]])
